import order from './order'
import product from './product'
import create from './create'
import cart from './cart'
import refund from './refund'
import stats from './stats'
import repurchase from './repurchase'
import tworldChat from './tworldChat'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    order,
    product,
    create,
    cart,
    refund,
    stats,
    repurchase,
    tworldChat,
  }
}
